import {Component, OnInit} from '@angular/core';
import {Technology, technologyToFilterIcon} from '../../../model/general/Technology';
import {projectIconDataMap} from '../../../helpers/projects.helper';
import {ProjectFilterService} from '../../../services/project-list/project-filter.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'digires-project-filter-technology',
  templateUrl: './project-filter-technology.component.html',
  styleUrls: ['./project-filter-technology.component.scss']
})
export class ProjectFilterTechnologyComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();

  readonly allTechnologies: Technology[] = Object.values(Technology);
  readonly technologyToTooltip = projectIconDataMap;
  readonly technologyToFilterIcon = technologyToFilterIcon;

  technologyToIncludedInFilter: {[tech: string]: boolean} = {
    [Technology.WIND_ONSHORE]: true,
    [Technology.SOLAR]: true,
    [Technology.STORAGE]: true,
  };

  constructor(
    private filterService: ProjectFilterService,
  ) { }

  ngOnInit() {
    this.filterService
      .observeProjectFilter()
      .pipe(takeUntil(this.destroy$))
      .subscribe(filter => {
        this.technologyToIncludedInFilter = {
          [Technology.WIND_ONSHORE]: filter.technology.includes(Technology.WIND_ONSHORE),
          [Technology.SOLAR]: filter.technology.includes(Technology.SOLAR),
          [Technology.STORAGE]: filter.technology.includes(Technology.STORAGE),
        };
        this.enableAllIfNoneActive();
      });
  }

  toggleTechnology(tech: Technology): void {
    this.technologyToIncludedInFilter[tech] = !this.technologyToIncludedInFilter[tech];
    this.enableAllIfNoneActive();
  }

  private enableAllIfNoneActive() {
    if (!this.allTechnologies.some(technology => this.technologyToIncludedInFilter[technology])) {
      this.technologyToIncludedInFilter = {
        [Technology.WIND_ONSHORE]: true,
        [Technology.SOLAR]: true,
        [Technology.STORAGE]: true,
      };
    }
  }

}
